<template>
  <HeadlessRadioGroup>
    <HeadlessRadioGroupLabel v-if="label">
      {{ label }}
    </HeadlessRadioGroupLabel>

    <div
      class="flex flex-nowrap items-stretch justify-between space-x-1 rounded-md border border-background-fg/6 bg-background-fg/5 p-0.5"
    >
      <HeadlessRadioGroupOption
        v-for="option in options"
        :key="option.label"
        as="template"
      >
        <div
          :class="[
            option.value === modelValue
              ? 'bg-background shadow-sm'
              : '',
            'flex-1 rounded p-1 text-center text-xs',
          ]"
          @click="onClickOption(option)"
        >
          <HeadlessRadioGroupLabel
            as="span"
            class="line-clamp-1"
          >
            {{ option.label }}
          </HeadlessRadioGroupLabel>
        </div>
      </HeadlessRadioGroupOption>
    </div>
  </HeadlessRadioGroup>
</template>

<script setup lang="ts">
export type ButtonSwitchOption = {
  value: boolean
  label: string
}

const props = defineProps<{
  modelValue?: boolean
  label?: string
  disabled?: boolean
  options: ButtonSwitchOption[]
}>()

const emit = defineEmits<{
  (eventName: "update:modelValue", value: boolean): void
}>()

const onClickOption = (option: ButtonSwitchOption) => {
  if (props.disabled) return

  emit("update:modelValue", option.value)
}
</script>
